import * as exTreetableContent from '../../content/treetable';
import type { TypeContainer } from '../../general/container';

import { mount, type TypeManagerApi, type TypeManagerConfig } from './mount';

// ----------------------------------------------------------------------------

type TypeCreateConfig = Record<string, any> & {
    container: TypeContainer;
    manager?: TypeManagerConfig;
};

// ----------------------------------------------------------------------------

function create(config: TypeCreateConfig): TypeManagerApi | undefined {
    if (!config.container?.parent) {
        throw new Error('Missing "container.parent", is required!');
    }

    const { manager, ...treetableConfig } = config;

    const treetable = exTreetableContent.create(treetableConfig);

    return mount(treetable.element, manager ?? treetableConfig);
}

function createMany(configs: TypeCreateConfig[] = []): TypeManagerApi[] {
    const managers: TypeManagerApi[] = [];

    for (const config of configs) {
        const manager = create(config);

        if (manager) {
            managers.push(manager);
        }
    }

    return managers;
}

// ----------------------------------------------------------------------------

export { create, createMany };
